import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import {
  createCustomField,
  deleteCustomField,
  reorderCustomFields,
  updateCustomField,
  useServiceDetail,
  type CustomField,
} from "@/lib/service-detail";
import { CustomFieldsManager } from "@/components/v2/CustomFieldsManager";

/**
 * Service Detail · Custom Fields tab — Pencil `Ah0ns`.
 * Thin wrapper that wires the per-service mutations into the shared
 * `<CustomFieldsManager />`.
 */
export function ServiceCustomFields() {
  const { id } = useParams<{ id: string }>();
  const qc = useQueryClient();
  const detail = useServiceDetail(id);
  const fields = (detail.data?.customFields ?? []) as CustomField[];

  const afterChange = () =>
    qc.invalidateQueries({ queryKey: ["service", id] });

  return (
    <CustomFieldsManager
      fields={fields}
      copy={{
        description:
          "Extra info collected for every booking. Click a row to configure options + advanced settings.",
        emptyDescription:
          "Add fields like Venue, Guest Count, or Photographer Preference so your team has everything they need before the booking.",
        newPlaceholder: "e.g. Venue, Guest Count, Photographer",
        deleteDescription:
          "Existing bookings keep their stored values for this field, but new bookings will no longer collect it.",
      }}
      onCreate={(body) => createCustomField(id!, body)}
      onUpdate={(fieldId, body) => updateCustomField(id!, fieldId, body)}
      onDelete={(fieldId) => deleteCustomField(id!, fieldId)}
      onReorder={(ids) => reorderCustomFields(id!, ids)}
      afterChange={afterChange}
    />
  );
}
